import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSidebarLeftHide12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconSidebarLeftHide12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M10.5 2H5v8h5.5a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5m-9 0H4v8H1.5a.5.5 0 0 1-.5-.5v-7a.5.5 0 0 1 .5-.5m0-1A1.5 1.5 0 0 0 0 2.5v7A1.5 1.5 0 0 0 1.5 11h9A1.5 1.5 0 0 0 12 9.5v-7A1.5 1.5 0 0 0 10.5 1zm7.153 3.586a.5.5 0 0 0-.707-.707L6.178 5.646 5.824 6l.354.354L7.946 8.12a.5.5 0 1 0 .707-.707L7.239 6z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconSidebarLeftHide12);
